import { css } from 'styled-components';

export const antdTable = css`
  .ant-pagination-item-active {
    color: ${({ theme }) => theme.baseBlue.a10};
    border-color: ${({ theme }) => theme.baseBlue.a10};
    background: ${({ theme }) => theme.white.a1};

    &:hover {
      color: ${({ theme }) => theme.baseBlue.a5};
      border-color: ${({ theme }) => theme.baseBlue.a5};
    }
  }

  .ant-pagination-item-active a {
    color: ${({ theme }) => theme.baseBlue.a10};

    &:hover {
      color: ${({ theme }) => theme.baseBlue.a5};
      border-color: ${({ theme }) => theme.baseBlue.a5};
    }
  }
`;
